module.exports = __webpack_public_path__ + "img/jiantou.4efe818a.svg";